import axios from 'axios';

export default {
  namespaced: true,
  state: {
    places: [],
    endpoint: '/ajax/places_search/',
    value: ''
  },

  getters: {
    filter: (state) => () => {
      return state.places.length ? state.places.map(place => place.description) : [];
    }
  },

  mutations: {
    setPlaces(state, places) {
      state.places = places;
    },

    setValue(state, value) {
      state.value = value;
    }
  },

  actions: {
    setValue({ state, commit, dispatch }, value) {
      commit('setValue', value);
      dispatch('fetch');
    },

    fetch({state, commit}) {
      if (!state.value) {
        return commit('setPlaces', {});
      }

      axios.get(`${state.endpoint}${state.value}`)
        .then(function (response) {
          commit('setPlaces', response.data.predictions);
        })
        .catch(function (error) {
          commit('setPlaces', {});
          console.log(error);
        });
    }
  }
};
